import { createContext } from 'react';
import { EntitySecurityContextValue } from '../../types';

export const EntitySecurityContext = createContext<EntitySecurityContextValue | null>(null);
